// @ts-ignore
import cln from 'classnames';

import { TabsMap, TabPane } from '@src/types';
import { ILLEGAL_TAB_INDEX } from '@src/utils/constant/common';

export * from './parseSearch';
export * from './i18n';
export * from './format';
export const classnames = cln as (...arg: any[]) => string;

export const findTabIndex = (tabsData: TabsMap, key: string) => {
  const tabItem = tabsData.data.find((item: TabPane) => {
    return item.key === key;
  });

  if (tabItem && tabItem.index) {
    return tabItem.index;
  }

  return ILLEGAL_TAB_INDEX;
};

export const getValueDepth1 = (target: any, key: string) => {
  if (!target) {
    return '';
  }

  return target[key];
};

export const getPathGroup = ({
  str,
  reg,
  defaultGroup
}: {
  str: string;
  reg: RegExp;
  defaultGroup: string;
}) => {
  const result = str.match(reg);

  if (result && result.length >= 2) {
    return result[1];
  }

  return defaultGroup;
};

export const openTargetBlankPage = (strUrl: string) => {
  window.open(`${strUrl}`, '_blank');
};

export const replaceCurrPage = (strUrl: string) => {
  location.replace(`${strUrl}`);
};

// 设置title
export const setTitle = (title: string) => {
  window[`beforeTitle`] = document.title;
  document.title = title;
};
// 重置title
export const resetTitle = (resetDefaultTitle?: boolean) => {
  let title = window[`beforeTitle`];
  if (resetDefaultTitle) {
    title = '快手技术社区';
  }
  document.title = title;
};

// 跳转圈子或者团队落地页
export const openGroupOrTeamIndex = (
  type: number | string | undefined,
  id: string | number | undefined
) => {
  let urlStr = '';
  if (typeof type === 'number') {
    if (type === 1) {
      urlStr = 'group';
    } else if (type === 2) {
      urlStr = 'team';
    }
  } else {
    if (type === 'GROUP') {
      urlStr = 'group';
    } else if (type === 'TEAM') {
      urlStr = 'team';
    }
  }

  window.open(`${process.env.REACT_APP_BASENAME ?? ''}/${urlStr}/home-page/${id}`, '_blank');
};
